<ng-select
  [items]="priceGroup"
  [clearable]="true"
  bindLabel="priceData.value"
  bindValue="groupId"
  class="dropdown-credit"
  [(ngModel)]="priceGroupSelected"
  placeholder="Selecione o Preço"
  (change)="selectPriceGroup($event)"
  [hideSelected]="true"
  notFoundText="Não encontrado"></ng-select>
